import { EDataSourceStatus } from '@/models/dataSource';
import { DateTime } from 'luxon';
import { FC, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useCampaignsActions } from '../context';
import { CreateCampaignFormInput, CreateCampaignFormOutput } from '../validation';
import { CampaignSummaryItem, CampaignSummaryItemField } from './CampaignSummaryItem';
import { CampaignStepSummaryProps } from './CampaignSummarySection';

export const DataSourceStepSummary: FC<CampaignStepSummaryProps> = ({ isStepCompleted }) => {
  const { t } = useTranslation();

  const { setStep } = useCampaignsActions();
  const { control } = useFormContext<CreateCampaignFormInput, unknown, CreateCampaignFormOutput>();

  const dataSources = useWatch({
    control,
    name: 'createdDataSources',
  });

  const dataSource = dataSources.at(dataSources.length - 1);

  const content = useMemo<CampaignSummaryItemField[]>(
    () =>
      dataSource
        ? [
            { field: dataSource.type.category, value: t(`data_sources:catalog.${dataSource.type.id}.title` as any) },
            { field: t('COMMON:id'), value: dataSource.id },
            { field: t('COMMON:data'), value: DateTime.fromISO(dataSource.createdOn).toFormat('dd-LL-yyyy') },
          ]
        : [],
    [dataSource]
  );

  return (
    <CampaignSummaryItem
      index={2}
      title={t('ALL:dataSourceSummary')}
      content={content}
      label={dataSource?.status === EDataSourceStatus.ACTIVE ? t('ALL:connected') : undefined}
      {...(isStepCompleted && { onClick: () => setStep('ImportDataSource') })}
    />
  );
};
